import { Box } from '@hover/blueprint';
import React, { useContext } from 'react';
import { useTransition } from 'react-spring';

import { Component as Back } from 'src/assets/icons/ui/back.svg';
import { Component as Redo } from 'src/assets/icons/ui/redo.svg';
import { Component as Share } from 'src/assets/icons/ui/share.svg';
import { Component as Undo } from 'src/assets/icons/ui/undo.svg';
import { getMobileExperiment } from 'src/modules/designStudio/helpers/mobileExperiments';
import { Feature } from 'src/shared/components/Feature';
import { FeatureFlag } from 'src/shared/constants';
import { useTranslate } from 'src/shared/hooks';
import { useReactNativeWebView } from 'src/shared/hooks/useReactNativeWebView';

import { Menu } from '../../constants';
import { historyContext } from '../../providers';

import { NavButton } from './NavButton';

interface PropTypes {
  menu: Menu | null;
  setMenu: (menu: Menu | null) => void;
}

const NavBar = ({ menu, setMenu }: PropTypes) => {
  const [isWebView, sendReactNativeMessage] = useReactNativeWebView();
  const showShare = getMobileExperiment(FeatureFlag.Mobile.MOBILE_DS_SHARE);
  const backButtonTransition = useTransition(!menu && isWebView, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: {
      duration: 200,
    },
  });

  const { undoDesignChange, redoDesignChange, canRedo, canUndo } = useContext(
    historyContext,
  );

  const t = useTranslate('designStudio');

  return (
    <Box
      flexDirection="row"
      justifyContent="space-between"
      left={300}
      margin={100}
      position="absolute"
      right={300}
      top={700}
    >
      <>
        <Box>
          {backButtonTransition.map(({ item: show, props: style, key }) =>
            show ? (
              <NavButton
                icon={Back}
                key={key}
                onPress={() => sendReactNativeMessage('handleNativeBack')}
                style={style}
                testId="back-button"
              />
            ) : (
              <Box key={key} />
            ),
          )}
        </Box>

        {!menu && (
          <Box gridColumnGap={200}>
            <Feature name={FeatureFlag.DesignStudio.DS_UNDO_REDO}>
              <>
                <NavButton
                  disabled={!canUndo}
                  icon={Undo}
                  label={t('undoRedo.undoButtonLabel')}
                  onPress={undoDesignChange}
                />
                <NavButton
                  disabled={!canRedo}
                  icon={Redo}
                  label={t('undoRedo.redoButtonLabel')}
                  onPress={redoDesignChange}
                />
              </>
            </Feature>
            {showShare && (
              <Feature name={FeatureFlag.DesignStudio.DS_SHARE}>
                <NavButton
                  icon={Share}
                  label={t('share.shareButtonLabel')}
                  onPress={() => setMenu(Menu.SHARE)}
                  testId="share"
                />
              </Feature>
            )}
          </Box>
        )}
      </>
    </Box>
  );
};

export { NavBar };
